<template>
  <v-container>
    <v-card>
      <v-toolbar dense color="secondary" flat>
        <v-toolbar-title>Accounts Audit</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <div>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.StartDate"
                    label="From"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.EndDate"
                    label="To"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                type="text"
                autocomplete="off"
                dense
                outlined
                v-model="record.Account"
                :items="accounts"
                label="Select Account"
                item-text="Name"
                item-value="id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="2">
              <v-btn color="accent" :loading="loader" @click="getReport">Audit Account</v-btn>
            </v-col>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12" xs="12" md="9" class="mb-2">
              <div>
                Balance as Of {{record.StartDate}}:
                <span
                  style="color: red"
                >{{auditData.openingQuantity && auditData.openingQuantity.toLocaleString()}}</span>
              </div>
            </v-col>

            <v-col cols="12" xs="12" md="9">
              <v-text-field v-model="search" dense label="Search"></v-text-field>
              <!-- table headers -->
              <v-data-table dense :headers="headers" :items="jdt1" :search="search">
                <template v-slot:item.ocrd="{ item }">
                  <span>{{item.ocrd && item.ocrd.Name}}</span>
                </template>

                <template v-slot:item.amount="{ item }">
                  <span v-if="item.TransType == 1">{{item.amount && item.amount}}</span>
                  <span v-else>-{{item.amount && item.amount}}</span>
                </template>

                <template v-slot:item.Balance="{ item }">
                  <span>{{item.Balance && item.Balance.toLocaleString()}}</span>
                </template>
              </v-data-table>
              <!-- end -->
            </v-col>

            <v-col cols="12" xs="12" md="6" class="mb-2">
              <div>
                Balance as Of {{record.EndDate}}:
                <span
                  style="color: red"
                >{{auditData.closingQuantity && auditData.closingQuantity.toLocaleString()}}</span>
              </div>
            </v-col>

            <v-col cols="12" xs="12" md="3" class="mb-2">
              <div>
                <span
                  v-if="auditData.totalDebit"
                >Total Debit: {{auditData.totalDebit.toLocaleString()}}</span>
              </div>
              <div>
                <span
                  v-if="auditData.totalCredit"
                >Total Credit: {{auditData.totalCredit.toLocaleString()}}</span>
              </div>
            </v-col>
          </v-row>

          <!-- products modal -->
          <v-dialog v-model="productsDialog" max-width="800px">
            <v-card>
              <v-toolbar dense color="accent" dark>
                <v-toolbar-title>Sold Products</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="productsDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row dense id="po">
                    <v-col cols="12" xs="12" md="4">
                      <span>Customer: {{ saleRecord.ocrd && saleRecord.ocrd.Name}}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="4">Receipt No: {{saleRecord.DocNum}}</v-col>

                    <v-col cols="12" xs="12" md="4">Date: {{saleRecord.DocDate}}</v-col>

                    <v-col cols="12" id="docForm">
                      <v-data-table
                        light
                        dense
                        :items-per-page="1000"
                        :headers="soldHeaders"
                        :items="soldItems"
                        item-key="id"
                        hide-default-footer
                        disable-sort
                        :mobile-breakpoint="0"
                      >
                        <template v-slot:item.Name="{ item }">{{item.Name}}</template>

                        <template v-slot:item.ref1="{ item }">{{item.ref1}}</template>

                        <template v-slot:item.Quantity="{ item }">{{item.Quantity}}</template>

                        <template v-slot:item.Price="{ item }">
                          <span v-if="item.Price">{{item.Price.toLocaleString()}}</span>
                        </template>

                        <template v-slot:item.DiscSum="{ item }">{{item.DiscSum}}</template>

                        <template v-slot:item.DisplayTotal="{ item }">{{item.DisplayTotal}}</template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of products modal -->

          <!-- jdt1 modal -->
          <v-dialog v-model="jdt1Dialog" max-width="800px">
            <v-card>
              <v-toolbar dense color="accent" dark>
                <v-toolbar-title>Journal Entry Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="jdt1Dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row dense>
                    <v-col cols="12">
                      <v-data-table
                        dense
                        :items-per-page="200"
                        :mobile-breakpoint="0"
                        :search="search"
                        :headers="detailHeaders"
                        :items="jdt1Details"
                      >
                        <!-- Credit template -->
                        <template v-slot:item.Credit="{ item }">
                          <span>{{item.Credit && item.Credit.toLocaleString()}}</span>
                        </template>
                        <!-- end -->

                        <!-- Debit template -->
                        <template v-slot:item.Debit="{ item }">
                          <span>{{item.Debit && item.Debit.toLocaleString()}}</span>
                        </template>
                        <!-- end -->
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of jdt1 modal -->

          <snackbar ref="snackbar"></snackbar>
        </div>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {},
      productsDialog: false,
      jdt1Dialog: false,
      saleRecord: {},
      soldItems: [],
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      brands: [],
      accounts: [],
      stockReport: [],
      categories: [],
      auditData: {},
      jdt1: [],
      jdt1Details: [],
      headers: [
        { text: "Remarks", value: "Remarks" },
        { text: "Customer/Supplier", value: "ocrd" },
        { text: "Amount", value: "amount" },
        { text: "Balance", value: "Balance" },
        { text: "Date", value: "DocDate" },
      ],
      soldHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "DisplayTotal" },
      ],
      detailHeaders: [
        { text: "Account", value: "oact.Name" },
        { text: "Debit", value: "Debit" },
        { text: "Credit", value: "Credit" },
        { text: "Remarks", value: "Remarks" },
        { text: "DocDate", value: "DocDate" },
      ],
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  methods: {
    moreDetails(data) {
      if (data.ObjType == 14) {
        this.getSaleProducts(data.DocEntry);
      }

      if (data.ObjType == 29) {
        this.journalDetails(data.OjdtId);
      }
    },
    getSaleProducts(val) {
      const self = this;
      this.$store.commit("loader", true);
      self.saleRecord = {};
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.saleRecord = res.ResponseData;
            const products = [];
            if (res.ResponseData.rows) {
              for (const row of res.ResponseData.rows) {
                row.Name = row.product.Name;
                row.DisplayTotal = row.LineTotal.toLocaleString();
                products.push(row);
              }
              self.soldItems = products;
              self.productsDialog = true;
              this.$store.commit("loader", false);
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    journalDetails(val) {
      const self = this;
      this.$store.commit("loader", true);
      self.jdt1Details = [];
      this.$store
        .dispatch("get", `/journal-records/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.jdt1Details = res.ResponseData;
            self.jdt1Dialog = true;
            self.$store.commit("loader", false);
          } else {
            this.$store.commit("loader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      if (this.record.Account == null || this.record.Account == undefined) {
        this.$refs.snackbar.show("Please select account!", "red");
      } else {
        const data = this.record;
        const url = "/audit-account";
        const self = this;
        this.$store.commit("loader", true);
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.auditData = res.ResponseData;
              self.jdt1 = res.ResponseData.jdt1;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
              self.$store.commit("loader", false);
            }
          })
          .catch((err) => {
            self.$store.commit("loader", false);
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    getAccounts() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getAccounts();
  },
};
</script>

<style lang="scss" scoped>
</style>